<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
export default {
  components: {},
  data() {
    return {
      comment_id: null,  //评论ID
      info: {},   //评论详情

      reply_content: null, //评论内容

      RefreshLoading: false, //刷新
      Loading: false, //加载
      Finished: false, //加载完成
      List: [],
      pagination: {
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },
    };
  },

  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
    var comment_id = this.$route.params.comment_id;
    this.comment_id = Number(comment_id);
    this.getPingInfo();
  },
  methods: {
    jumpExpert(item){
      if(['temp','official','manager'].indexOf(item.userType)===-1){
        this.$glf.goUrl('push','/expert_info/'+item.userId);
      }
      // if(item.userType!=='temp'){
      //   this.$glf.goUrl('push','/expert_info/'+item.userId);
      // }
    },

    //获取评论详情
    getPingInfo(){
      var params = {
          id: this.comment_id,
        };
      this.$api.articleReplyDetail(params).then((res) => {
        if (!res.data[0]) {
          this.$toast("未找到相关文章评论");
          this.$router.back();
        } else {
          var fo = res.data[0];
          this.info = fo;
        }
      });
    },

    //给评论点赞
    dealPingZan(){
      if(!this.info.myThumbupStatus){
        //点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleReplyThumbupAdd({replyId:this.info.id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '点赞成功！',tip:'感谢您的点赞'});
          this.getPingInfo();
        })
      }else{
        //取消点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleReplyThumbupDelete({replyId:this.info.id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '取消点赞成功！',tip:'我会继续努力地'});
          this.getPingInfo();
        })
      }
    },

    //给评论回复点赞
    dealPingReplyZan(row,index){
      if(!row.myThumbupStatus){
        //点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleReplyChildThumbupAdd({replyChildId:row.id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '点赞成功！',tip:'感谢您的点赞'});
          if(index===-1){
            this.getPingInfo();
          }else{
            this.List[index].myThumbupStatus = true;
            this.List[index].thumbupNum += 1;
          }
        })
      }else{
        //取消点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleReplyChildThumbupDelete({replyChildId:row.id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '取消点赞成功！',tip:'我会继续努力地'});
          if(index===-1){
            this.getPingInfo();
          }else{
            this.List[index].myThumbupStatus = false;
            this.List[index].thumbupNum -= 1;
          }
        })
      }
    },

    //提交评论
    subReply() {
      if (this.$glf.isEmpty(this.reply_content)) {
        this.$toast("评论内容不能为空");
        return false;
      }
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var params = {
        articleId: this.info.articleId,
        replyId: this.comment_id,
        content: this.reply_content,
      };
      this.$api.articleReplyChildAdd(params).then((res) => {
        this.reply_content = null;
        this.$toast("评论成功");
        this.refreshList();
        this.getPingInfo();
      });
    },

    //刷新列表
    refreshList() {
      this.Finished = false;
      this.pagination.index = 0;
      this.loadList().then((res) => {
        this.RefreshLoading = false;
      });
    },
    //加载列表
    loadList() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index+1,
          size: this.pagination.size,
        },
        replyId: this.comment_id,
        // condition: {
        //   stc: "1",
        //   items: [{ code: "replyId", opc: "=", values: [this.comment_id] }],
        // },
        sort: [{ code: "ct", desc: true }],
      };
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.$api.articleReplyChildPage(params).then((res) => {
          var data = res.data;
          var list = data.data || [];
          if (data.pagination.index === 1) {
            _this.List = list;
          } else {
            _this.List = _this.List.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.List.length >= data.pagination.total) {
            _this.Finished = true;
          }
          // 加载状态结束
          _this.Loading = false;
          resolve();
        });
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/article_comment/index.vue